<form class="mmb-form" #formRegisterDetails="ngForm" name="formRegisterDetails"
  (submit)="handleSubmitResetPassword(formRegisterDetails.value, $event)" novalidate>

  <h3 class="page__heading text-dark-blue margin-bottom-24">
    {{ appCopy.panelHeader["title" + selectedLanguage] }}
  </h3>

  <div class="panel">
    <div class="panel__header">{{ appCopy.panelHeader["description" + selectedLanguage] }}</div>
    <div class="panel__body">
      <div class="section">
        <p class="text-muted text-dark-blue">
          {{ appCopy.panelHeader["heading" + selectedLanguage] }}
        </p>
      </div>

      <div class="section section__colored">
        <div class="row" *ngIf="!userHasAccountDetails">
          <div class="col-xs-12 margin-bottom-16">
            <div class="form-group">
              <input class="form-control" [ngClass]="{ 'has-error': email.invalid && email.dirty }" id="email"
                name="email" type="email" #email="ngModel" [pattern]="emailPattern" [ngModel]="userEmail" ngModel
                required appCheckEmpty [placeholder]="appCopy.panelHeader['emailPlaceholder' + selectedLanguage]"
                readonly />

              <p class="help-block text-danger" *ngIf="email?.errors?.pattern">
                {{ appCopy.panelHeader["validEmail" + selectedLanguage] }}
              </p>
              <p class="help-block text-danger" *ngIf="email.invalid && email.dirty && !email?.errors?.pattern">
                {{ appCopy.panelHeader["warningEmail" + selectedLanguage] }}
              </p>
            </div>
          </div>
          <div class="col-xs-4 col-sm-3">
            <div class="form-group with-select">
              <select class="form-control no-label" [ngClass]="{ 'has-error': UserTitle.invalid && UserTitle.dirty }"
                id="UserTitle" name="UserTitle" #UserTitle="ngModel" ngModel required>
                <option value="" disabled>
                  {{ appCopy.panelHeader["titlePlaceholder" + selectedLanguage] }}
                </option>
                <option value="Mr">
                  {{ appCopy.panelHeader["mrOption" + selectedLanguage] }}
                </option>
                <option value="Ms">
                  {{ appCopy.panelHeader["msOption" + selectedLanguage] }}
                </option>
                <option value="Mrs">
                  {{ appCopy.panelHeader["mrsOption" + selectedLanguage] }}
                </option>
                <option value="Miss">
                  {{ appCopy.panelHeader["missOption" + selectedLanguage] }}
                </option>
              </select>
              <p class="help-block text-danger" *ngIf="UserTitle.invalid && UserTitle.dirty">
                {{ appCopy.panelHeader["userTitleWarning" + selectedLanguage] }}
              </p>
            </div>
          </div>
          <div class="col-xs-8 col-sm-9">
            <div class="form-group">
              <input class="form-control" [ngClass]="{ 'has-error': UserFirstName.invalid && UserFirstName.dirty }"
                id="UserFirstName" name="UserFirstName" [pattern]="namePattern" type="text"
                #UserFirstName="ngModel" [placeholder]="appCopy.panelHeader['fNamePlaceholder' + selectedLanguage]"
                ngModel required appCheckEmpty />
              <i class="icon control-validation-state"></i>

              <p class="help-block text-danger" *ngIf="
                  UserFirstName.invalid &&
                  UserFirstName.dirty &&
                  !UserFirstName.errors?.pattern
                ">
                {{ appCopy.panelHeader["fNameeWarning" + selectedLanguage] }}
              </p>
              <p class="help-block text-danger" *ngIf="UserFirstName.errors?.pattern">
                {{ appCopy.panelHeader[ "errorTextBookerNameInvalid" + selectedLanguage ] }}
              </p>
            </div>
          </div>
          <div class="col-xs-12 margin-top-16">
            <div class="form-group">
              <input class="form-control" [ngClass]="{
                  'has-error': UserLastName.invalid && UserLastName.dirty
                }" id="UserLastName" name="UserLastName" [pattern]="namePattern" type="text"
                #UserLastName="ngModel" ngModel
                [placeholder]="appCopy.panelHeader['lNamePlaceholder' + selectedLanguage]" required appCheckEmpty />
              <i class="icon control-validation-state"></i>

              <p class="help-block text-danger" *ngIf="
                  UserLastName.invalid &&
                  UserLastName.dirty &&
                  !UserLastName.errors?.pattern
                ">
                {{ appCopy.panelHeader["lNameeWarning" + selectedLanguage] }}
              </p>
              <p class="help-block text-danger" *ngIf="UserLastName.errors?.pattern">
                {{ appCopy.panelHeader[ "errorTextBookerNameInvalid" + selectedLanguage ] }}
              </p>
            </div>
          </div>
          <div class="col-xs-12 margin-top-16">
            <div class="multiple-inputs clearfix">
              <div class="col-xs-4 col-sm-3 form-group with-select">
                <div class="with-select__custom-value">+{{ countryCode }}</div>
                <ng-select class="form-control form-control--no-label custom"
                  [ngClass]="{'has-error': UserCountryCode.invalid && UserCountryCode.dirty }" id="UserCountryCode"
                  name="UserCountryCode" #UserCountryCode="ngModel" [(ngModel)]="countryCode"
                  (ngModelChange)="validatePhoneNumber($event, UserCountryCode.value)" required ngModel
                  [clearable]="false" [items]="countryCodes.all" groupBy="label" bindLabel="displayText"
                  bindValue="countryCode"
                  [notFoundText]="appCopy.panelHeader['bookerCountryNotFound'+selectedLanguage]">

                </ng-select>


                <p class="help-block text-danger" *ngIf="UserCountryCode.invalid && UserCountryCode.dirty">
                  {{ appCopy.panelHeader["countryCodeWarning" + selectedLanguage] }}
                </p>
              </div>
              <div class="col-xs-8 col-sm-9 form-group">
                <input class="form-control form-control--no-label"
                  [ngClass]="{ 'has-error': UserPhone.invalid && UserPhone.dirty || UserPhone.errors?.incorrect }"
                  type="tel" id="UserPhone" (blur)="validatePhoneNumber(UserCountryCode.value, UserPhone.value)"
                  [placeholder]="appCopy.panelHeader['phoneNumberText'+selectedLanguage]" name="UserPhone"
                  #UserPhone="ngModel" [pattern]="phonePattern" ngModel required appCheckEmpty />
                <i class="icon control-validation-state"></i>
                <p class="help-block text-danger" *ngIf="UserPhone.errors?.pattern">
                  {{ appCopy.panelHeader[ "countryCodeDigitsWarning" + selectedLanguage ] }}
                </p>
                <p class="help-block text-danger" *ngIf="
                    UserPhone.invalid &&
                    !UserPhone.errors?.pattern &&
                    UserPhone.dirty
                  ">
                  {{ appCopy.panelHeader[ "contactNumberWarning" + selectedLanguage ] }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group  margin-top-16" [ngClass]="{'margin-top-16' : !userHasAccountDetails}">
          <div class="passwordIcon">
          <input class="form-control" [ngClass]="{ 'has-error': Password.invalid && Password.dirty }" id="Password"
            name="Password" [type]="showPassword.password ? 'text' : 'password'" #Password="ngModel" [(ngModel)]="passwordValues.password1" ngModel required
            appCheckEmpty [placeholder]=" appCopy.panelHeader['loginPasswordLabel' + selectedLanguage] " (ngModelChange)="passwordsEqual(true)" />
            <div class="btntoggle" (click)="togglePasswordVisibility('password')">
              <ng-container *ngIf="showPassword.password; else showPass">
                <i class="icon-eye-blocked"></i>
              </ng-container>
              <ng-template #showPass>
                <i class="icon-eye"></i>
              </ng-template>
            </div>
          </div>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="Password.invalid && Password.dirty">
            {{ appCopy.panelHeader["warningEnterPassword" + selectedLanguage] }}
          </p>
        </div>

        <div class="form-group  margin-top-16">
          <div class="passwordIcon">
          <input class="form-control" [ngClass]="{
              'has-error':
                (PasswordVerify.invalid && PasswordVerify.dirty) ||
                !passwordMatch
            }" id="PasswordVerify" name="PasswordVerify" [type]="showPassword.confirmPassword ? 'text' : 'password'" #PasswordVerify="ngModel"
            [(ngModel)]="passwordValues.password2" (ngModelChange)="passwordsEqual()" ngModel
            [placeholder]=" appCopy.panelHeader['loginRePasswordLabel' + selectedLanguage]" required appCheckEmpty />
            <div class="btntoggle" (click)="togglePasswordVisibility('confirmPassword')">
              <ng-container *ngIf="showPassword.confirmPassword; else showConfirm">
                <i class="icon-eye-blocked"></i>
              </ng-container>
              <ng-template #showConfirm>
                <i class="icon-eye"></i>
              </ng-template>
            </div>
          </div>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="PasswordVerify.invalid && PasswordVerify.dirty">
            {{ appCopy.panelHeader[ "warningReEnterPassword" + selectedLanguage ] }}
          </p>
          <p class="help-block text-danger" *ngIf="!passwordMatch">
            {{ appCopy.panelHeader["warningMatchPassword" + selectedLanguage] }}
          </p>
        </div>
      </div>

      <div class="section section__actions">
        <button type="submit" class="btn btn-purple btn-lg" [disabled]="formRegisterDetails.invalid || !passwordMatch || !phoneNumberValid">
          <div class="loader-container-btn" *ngIf="showLoader">
            <div class="loader loader--white">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          {{ appCopy.panelHeader["buttonSubmit" + selectedLanguage] }}
        </button>
      </div>
    </div>
  </div>
</form>
